import { useParams } from "react-router";
import { ProductSearchPagePresentation } from "./ProductSearchPagePresentation";
import { useState } from "react";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";

export const ProductSearchPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const { type } = useParams<{ type: string }>();
  const isGlobalSearch = type === "global";

  return (
    <ProductSearchPagePresentation
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      shouldShowCloseButton={false}
      handleClose={() => {}}
      itemCardRenderType={SearchItemCardRenderType.link}
      shouldHideSPRItems={!isGlobalSearch}
      shouldHideLocalCombinationItems={!isGlobalSearch}
    />
  );
};
